import { render, staticRenderFns } from "./Org.vue?vue&type=template&id=2a2eb9da&scoped=true&"
import script from "./Org.vue?vue&type=script&lang=ts&"
export * from "./Org.vue?vue&type=script&lang=ts&"
import style0 from "./Org.vue?vue&type=style&index=0&id=2a2eb9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2eb9da",
  null
  
)

export default component.exports